import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TapestrySidenavService } from '@predictiveindex/tapestry';
import {
    InspireAccessStatus,
    inspire2OnboardingLink
} from '../../../constants-types';
import { Person } from '../../../core-data-model/Person.model';
import { OrgMemberService } from '../../../core-services';
import { TranslationService } from '../../../translations';

@Component({
    selector: 'global-search-inspire-cta',
    templateUrl: './global-search-inspire-cta.component.html',
    styleUrls: ['./global-search-inspire-cta.component.less'],
    standalone: false
})
export class GlobalSearchInspireCtaComponent implements OnInit {
    @Input()
    firstName = '';

    @Input()
    email = '';

    @Input()
    personViewableInInspire = false;

    @Input()
    person: Person = null;

    @Input()
    inspireAccessStatus: InspireAccessStatus = InspireAccessStatus.Unknown;

    showInviteButton: boolean;

    constructor(
        public TR: TranslationService,
        private router: Router,
        private sideNavService: TapestrySidenavService,
        private orgMemberService: OrgMemberService
    ) {}

    ngOnInit(): void {
        this.showInviteButton =
            this.inspireAccessStatus === InspireAccessStatus.HasAccess &&
            !this.personViewableInInspire;
    }

    async primaryButtonClicked() {
        if (this.showInviteButton) {
            let userGuid: string = null;
            // Invite person to Inspire
            if (this.person.userId) {
                const orgMember = await this.orgMemberService.getOrgMember(
                    this.person.id
                );
                userGuid = orgMember.userGuid;
            }
            await this.orgMemberService.sendInspireInvite([
                {
                    userId: userGuid,
                    email: this.email
                }
            ]);
        } else {
            // Send to Inspire onboarding view
            await this.router.navigateByUrl(inspire2OnboardingLink);
            this.sideNavService.close();
        }
    }
}
